import { render, staticRenderFns } from "./Id.vue?vue&type=template&id=a4649130&scoped=true"
import script from "./Id.vue?vue&type=script&lang=js"
export * from "./Id.vue?vue&type=script&lang=js"
import style0 from "./Id.vue?vue&type=style&index=0&id=a4649130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4649130",
  null
  
)

export default component.exports